import { Quill } from 'vue2-editor';

const Embed = Quill.import('blots/embed');

class QuillHashtag extends Embed {
    static className = 'quill-hashtag';

    static tagName = 'span';

    static blotName = 'hashtag';

    static create(data) {
      const node = super.create();
      const { value, format } = data;

      node.innerHTML = value;
      node.setAttribute('contenteditable', false);

      if (format.font) {
        node.classList.add(`ql-font-${format.font}`);
      }
      return node;
    }
}
export default QuillHashtag;
